const STORAGE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://localhost:8000/storage'
    : 'https://api.pa.uz/storage';

export const resolveImage = (path) => (path ? `${STORAGE_URL}/${path}` : '/assets/no-photo.jpg');

export default STORAGE_URL;